import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { MobileShell } from "@/components/MobileShell";
import { Wordmark, Button, Field, Input } from "@/components/kit";
import { api, formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError("This reset link is missing its token."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileShell>
      <div className="px-7 pt-16 lg:pt-10 pb-10 min-h-screen flex flex-col">
        <Wordmark className="lg:hidden" />
        {done ? (
          <div className="mt-16 text-center animate-rise" data-testid="reset-success">
            <div className="mx-auto h-14 w-14 rounded-full bg-[#F1EEE7] flex items-center justify-center">
              <CheckCircle2 className="h-7 w-7 text-[#3D6B56]" strokeWidth={1.6} />
            </div>
            <h1 className="font-serif text-2xl text-[#1F2B26] mt-6">Password updated</h1>
            <p className="font-sans text-sm text-[#5F6D66] mt-3">You can now sign in with your new password.</p>
            <Button className="mt-8" onClick={() => navigate("/login")} data-testid="reset-to-login-btn">Sign in</Button>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-3xl text-[#1F2B26] mt-8">Choose a new password</h1>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <Field label="New password" hint="At least 8 characters, with a letter and a number.">
                <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" data-testid="reset-password-input" />
              </Field>
              {error && <p className="font-sans text-sm text-[#9B4B45]" data-testid="reset-error">{error}</p>}
              <Button type="submit" className="w-full" size="lg" disabled={loading} data-testid="reset-submit-btn">
                {loading ? "Updating…" : "Update password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </MobileShell>
  );
}
